import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-toolbar.pcss';

import '@polymer/iron-icon'
import '@polymer/iron-image'
import '@polymer/app-layout/app-toolbar/app-toolbar'
import '@polymer/paper-icon-button'

import './../tt-share-button/tt-share-button'
import {TTUtil} from "../../utils/tt-util";

import 'web-animations-js/web-animations-next-lite.min'

export default class TTToolbar extends LitElement {
    static get properties() {
        return {
            title: {
                type: String
            },
            showBackButton: {
                type: Boolean,
                attribute: 'show-back-button'
            },
            shareUrl: {
                type: String,
                attribute: 'share-url'
            },
            user: {
                type: Object
            }
        };
    }

    constructor() {
        super();
        this.title = 'Tischtennis Liveticker';
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
<app-toolbar role="content">

    ${this.showBackButton ? this.renderBack() : this.renderMenu()}

    <div main-title role="content">${this.title}</div>
    <tt-share-button .url=${this.shareUrl}></tt-share-button>
    
    ${this.user ? this.renderAvatar() : ""}
    
    <slot name="buttons"></slot>

</app-toolbar>
`;
    }

    renderBack() {
        return html`
        <paper-icon-button icon="arrow-back" @click=${this.goBack}>
        </paper-icon-button>
        `;
    }

    renderMenu() {
        return html`
        <paper-icon-button icon="menu" drawer-toggle class="icon" @click=${this.onDrawerIconClick}>
        </paper-icon-button>
        `;
    }

    renderAvatar() {
        return html`
            <div style="position: relative; height: 34px;">
                <iron-image id="button" src=${this.user.photoURL}
                            sizing="contain"
                            @click=${() => {
                                let menu = this.shadowRoot.getElementById(
                                        'menu');
                                let button = this.shadowRoot.getElementById(
                                        'button');
                                menu.anchor = button;
                                menu.show();
                            }}>
                </iron-image>

                <mwc-menu owerflow id="menu"
                          corner="BOTTOM_END"
                          menuCorner="END">
                    <mwc-list-item graphic="icon" @click=${this.onLogoutClicked}>
                        Logout
                        <iron-icon icon="small:sign-out" slot="graphic">
                        </iron-icon>
                    </mwc-list-item>
                </mwc-menu>
            </div>
        `;
    }

    onLogoutClicked() {
        TTUtil.getApp(this)
            .logout();
    }

    goBack() {
        TTUtil.getApp(this)
            .navigateBack();
    }

    onDrawerIconClick() {
        TTUtil.getApp(this)
            .openDrawer();
    }
}

window.customElements.define('tt-toolbar', TTToolbar);
